/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOneBaseMgmtThermoformingBaseControllerThermoformingBase } from '../fn/thermoforming/create-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { CreateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params } from '../fn/thermoforming/create-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock } from '../fn/thermoforming/create-one-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { CreateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params } from '../fn/thermoforming/create-one-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole } from '../fn/thermoforming/create-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { CreateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params } from '../fn/thermoforming/create-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock } from '../fn/thermoforming/create-one-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { CreateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params } from '../fn/thermoforming/create-one-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { deleteOneBaseMgmtThermoformingBaseControllerThermoformingBase } from '../fn/thermoforming/delete-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { DeleteOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params } from '../fn/thermoforming/delete-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { deleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock } from '../fn/thermoforming/delete-one-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { DeleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params } from '../fn/thermoforming/delete-one-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { deleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole } from '../fn/thermoforming/delete-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { DeleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params } from '../fn/thermoforming/delete-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { deleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock } from '../fn/thermoforming/delete-one-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { DeleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params } from '../fn/thermoforming/delete-one-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { getManyBaseMgmtThermoformingBaseControllerThermoformingBase } from '../fn/thermoforming/get-many-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { GetManyBaseMgmtThermoformingBaseControllerThermoformingBase$Params } from '../fn/thermoforming/get-many-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { getManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock } from '../fn/thermoforming/get-many-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { GetManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params } from '../fn/thermoforming/get-many-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { getManyBaseMgmtThermoformingInsoleControllerThermoformingInsole } from '../fn/thermoforming/get-many-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { GetManyBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params } from '../fn/thermoforming/get-many-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { getManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock } from '../fn/thermoforming/get-many-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { GetManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params } from '../fn/thermoforming/get-many-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { getManyBaseThermoformingBaseControllerThermoformingBase } from '../fn/thermoforming/get-many-base-thermoforming-base-controller-thermoforming-base';
import { GetManyBaseThermoformingBaseControllerThermoformingBase$Params } from '../fn/thermoforming/get-many-base-thermoforming-base-controller-thermoforming-base';
import { getManyBaseThermoformingInsoleControllerThermoformingInsole } from '../fn/thermoforming/get-many-base-thermoforming-insole-controller-thermoforming-insole';
import { GetManyBaseThermoformingInsoleControllerThermoformingInsole$Params } from '../fn/thermoforming/get-many-base-thermoforming-insole-controller-thermoforming-insole';
import { GetManyThermoformingBaseResponseDto } from '../models/get-many-thermoforming-base-response-dto';
import { GetManyThermoformingBaseStockResponseDto } from '../models/get-many-thermoforming-base-stock-response-dto';
import { GetManyThermoformingInsoleResponseDto } from '../models/get-many-thermoforming-insole-response-dto';
import { GetManyThermoformingInsoleStockResponseDto } from '../models/get-many-thermoforming-insole-stock-response-dto';
import { getOneBaseMgmtThermoformingBaseControllerThermoformingBase } from '../fn/thermoforming/get-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { GetOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params } from '../fn/thermoforming/get-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { getOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock } from '../fn/thermoforming/get-one-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { GetOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params } from '../fn/thermoforming/get-one-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { getOneBaseMgmtThermoformingInsoleControllerThermoformingInsole } from '../fn/thermoforming/get-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { GetOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params } from '../fn/thermoforming/get-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { getOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock } from '../fn/thermoforming/get-one-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { GetOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params } from '../fn/thermoforming/get-one-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { getOneBaseThermoformingBaseControllerThermoformingBase } from '../fn/thermoforming/get-one-base-thermoforming-base-controller-thermoforming-base';
import { GetOneBaseThermoformingBaseControllerThermoformingBase$Params } from '../fn/thermoforming/get-one-base-thermoforming-base-controller-thermoforming-base';
import { getOneBaseThermoformingInsoleControllerThermoformingInsole } from '../fn/thermoforming/get-one-base-thermoforming-insole-controller-thermoforming-insole';
import { GetOneBaseThermoformingInsoleControllerThermoformingInsole$Params } from '../fn/thermoforming/get-one-base-thermoforming-insole-controller-thermoforming-insole';
import { mgmtThermoformingBaseControllerSortDown } from '../fn/thermoforming/mgmt-thermoforming-base-controller-sort-down';
import { MgmtThermoformingBaseControllerSortDown$Params } from '../fn/thermoforming/mgmt-thermoforming-base-controller-sort-down';
import { mgmtThermoformingBaseControllerSortUp } from '../fn/thermoforming/mgmt-thermoforming-base-controller-sort-up';
import { MgmtThermoformingBaseControllerSortUp$Params } from '../fn/thermoforming/mgmt-thermoforming-base-controller-sort-up';
import { mgmtThermoformingBaseStockControllerGetAlerts } from '../fn/thermoforming/mgmt-thermoforming-base-stock-controller-get-alerts';
import { MgmtThermoformingBaseStockControllerGetAlerts$Params } from '../fn/thermoforming/mgmt-thermoforming-base-stock-controller-get-alerts';
import { mgmtThermoformingBaseStockControllerGetQuantityDetails } from '../fn/thermoforming/mgmt-thermoforming-base-stock-controller-get-quantity-details';
import { MgmtThermoformingBaseStockControllerGetQuantityDetails$Params } from '../fn/thermoforming/mgmt-thermoforming-base-stock-controller-get-quantity-details';
import { mgmtThermoformingInsoleControllerSortDown } from '../fn/thermoforming/mgmt-thermoforming-insole-controller-sort-down';
import { MgmtThermoformingInsoleControllerSortDown$Params } from '../fn/thermoforming/mgmt-thermoforming-insole-controller-sort-down';
import { mgmtThermoformingInsoleControllerSortUp } from '../fn/thermoforming/mgmt-thermoforming-insole-controller-sort-up';
import { MgmtThermoformingInsoleControllerSortUp$Params } from '../fn/thermoforming/mgmt-thermoforming-insole-controller-sort-up';
import { mgmtThermoformingInsoleStockControllerGetAlerts } from '../fn/thermoforming/mgmt-thermoforming-insole-stock-controller-get-alerts';
import { MgmtThermoformingInsoleStockControllerGetAlerts$Params } from '../fn/thermoforming/mgmt-thermoforming-insole-stock-controller-get-alerts';
import { mgmtThermoformingInsoleStockControllerGetQuantityDetails } from '../fn/thermoforming/mgmt-thermoforming-insole-stock-controller-get-quantity-details';
import { MgmtThermoformingInsoleStockControllerGetQuantityDetails$Params } from '../fn/thermoforming/mgmt-thermoforming-insole-stock-controller-get-quantity-details';
import { recoverOneBaseMgmtThermoformingBaseControllerThermoformingBase } from '../fn/thermoforming/recover-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { RecoverOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params } from '../fn/thermoforming/recover-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { recoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole } from '../fn/thermoforming/recover-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { RecoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params } from '../fn/thermoforming/recover-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { ThermoformingBase } from '../models/thermoforming-base';
import { ThermoformingBaseStock } from '../models/thermoforming-base-stock';
import { ThermoformingBaseStockQuantityDetails } from '../models/thermoforming-base-stock-quantity-details';
import { ThermoformingInsole } from '../models/thermoforming-insole';
import { ThermoformingInsoleStock } from '../models/thermoforming-insole-stock';
import { ThermoformingInsoleStockQuantityDetails } from '../models/thermoforming-insole-stock-quantity-details';
import { updateOneBaseMgmtThermoformingBaseControllerThermoformingBase } from '../fn/thermoforming/update-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { UpdateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params } from '../fn/thermoforming/update-one-base-mgmt-thermoforming-base-controller-thermoforming-base';
import { updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock } from '../fn/thermoforming/update-one-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { UpdateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params } from '../fn/thermoforming/update-one-base-mgmt-thermoforming-base-stock-controller-thermoforming-base-stock';
import { updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole } from '../fn/thermoforming/update-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { UpdateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params } from '../fn/thermoforming/update-one-base-mgmt-thermoforming-insole-controller-thermoforming-insole';
import { updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock } from '../fn/thermoforming/update-one-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';
import { UpdateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params } from '../fn/thermoforming/update-one-base-mgmt-thermoforming-insole-stock-controller-thermoforming-insole-stock';

@Injectable({ providedIn: 'root' })
export class ThermoformingApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtThermoformingBaseControllerThermoformingBase()` */
  static readonly GetManyBaseMgmtThermoformingBaseControllerThermoformingBasePath = '/api/mgmt/thermoforming-base';

  /**
   * Retrieve multiple ThermoformingBases.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtThermoformingBaseControllerThermoformingBase()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params?: GetManyBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyThermoformingBaseResponseDto>> {
    const obs = getManyBaseMgmtThermoformingBaseControllerThermoformingBase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ThermoformingBases.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtThermoformingBaseControllerThermoformingBase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtThermoformingBaseControllerThermoformingBase(params?: GetManyBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<GetManyThermoformingBaseResponseDto> {
    const resp = this.getManyBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyThermoformingBaseResponseDto>): GetManyThermoformingBaseResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtThermoformingBaseControllerThermoformingBase()` */
  static readonly CreateOneBaseMgmtThermoformingBaseControllerThermoformingBasePath = '/api/mgmt/thermoforming-base';

  /**
   * Create a single ThermoformingBase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtThermoformingBaseControllerThermoformingBase()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params: CreateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
    const obs = createOneBaseMgmtThermoformingBaseControllerThermoformingBase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single ThermoformingBase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtThermoformingBaseControllerThermoformingBase(params: CreateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<ThermoformingBase> {
    const resp = this.createOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBase>): ThermoformingBase => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtThermoformingBaseControllerThermoformingBase()` */
  static readonly GetOneBaseMgmtThermoformingBaseControllerThermoformingBasePath = '/api/mgmt/thermoforming-base/{id}';

  /**
   * Retrieve a single ThermoformingBase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtThermoformingBaseControllerThermoformingBase()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params: GetOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
    const obs = getOneBaseMgmtThermoformingBaseControllerThermoformingBase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ThermoformingBase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtThermoformingBaseControllerThermoformingBase(params: GetOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<ThermoformingBase> {
    const resp = this.getOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBase>): ThermoformingBase => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtThermoformingBaseControllerThermoformingBase()` */
  static readonly DeleteOneBaseMgmtThermoformingBaseControllerThermoformingBasePath = '/api/mgmt/thermoforming-base/{id}';

  /**
   * Delete a single ThermoformingBase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtThermoformingBaseControllerThermoformingBase()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params: DeleteOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtThermoformingBaseControllerThermoformingBase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single ThermoformingBase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtThermoformingBaseControllerThermoformingBase(params: DeleteOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtThermoformingBaseControllerThermoformingBase()` */
  static readonly UpdateOneBaseMgmtThermoformingBaseControllerThermoformingBasePath = '/api/mgmt/thermoforming-base/{id}';

  /**
   * Update a single ThermoformingBase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtThermoformingBaseControllerThermoformingBase()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params: UpdateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
    const obs = updateOneBaseMgmtThermoformingBaseControllerThermoformingBase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single ThermoformingBase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtThermoformingBaseControllerThermoformingBase(params: UpdateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<ThermoformingBase> {
    const resp = this.updateOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBase>): ThermoformingBase => r.body)
    );
  }

  /** Path part for operation `mgmtThermoformingBaseControllerSortUp()` */
  static readonly MgmtThermoformingBaseControllerSortUpPath = '/api/mgmt/thermoforming-base/{id}/sort-up';

  /**
   * Sort Up
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtThermoformingBaseControllerSortUp()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingBaseControllerSortUp$Response(params: MgmtThermoformingBaseControllerSortUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
    const obs = mgmtThermoformingBaseControllerSortUp(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sort Up
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtThermoformingBaseControllerSortUp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingBaseControllerSortUp(params: MgmtThermoformingBaseControllerSortUp$Params, context?: HttpContext): Observable<ThermoformingBase> {
    const resp = this.mgmtThermoformingBaseControllerSortUp$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBase>): ThermoformingBase => r.body)
    );
  }

  /** Path part for operation `mgmtThermoformingBaseControllerSortDown()` */
  static readonly MgmtThermoformingBaseControllerSortDownPath = '/api/mgmt/thermoforming-base/{id}/sort-down';

  /**
   * Sort Down
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtThermoformingBaseControllerSortDown()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingBaseControllerSortDown$Response(params: MgmtThermoformingBaseControllerSortDown$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
    const obs = mgmtThermoformingBaseControllerSortDown(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sort Down
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtThermoformingBaseControllerSortDown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingBaseControllerSortDown(params: MgmtThermoformingBaseControllerSortDown$Params, context?: HttpContext): Observable<ThermoformingBase> {
    const resp = this.mgmtThermoformingBaseControllerSortDown$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBase>): ThermoformingBase => r.body)
    );
  }

  /** Path part for operation `recoverOneBaseMgmtThermoformingBaseControllerThermoformingBase()` */
  static readonly RecoverOneBaseMgmtThermoformingBaseControllerThermoformingBasePath = '/api/mgmt/thermoforming-base/{id}/recover';

  /**
   * Recover one ThermoformingBase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recoverOneBaseMgmtThermoformingBaseControllerThermoformingBase()` instead.
   *
   * This method doesn't expect any request body.
   */
  recoverOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params: RecoverOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = recoverOneBaseMgmtThermoformingBaseControllerThermoformingBase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Recover one ThermoformingBase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recoverOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recoverOneBaseMgmtThermoformingBaseControllerThermoformingBase(params: RecoverOneBaseMgmtThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<void> {
    const resp = this.recoverOneBaseMgmtThermoformingBaseControllerThermoformingBase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtThermoformingInsoleControllerThermoformingInsole()` */
  static readonly GetManyBaseMgmtThermoformingInsoleControllerThermoformingInsolePath = '/api/mgmt/thermoforming-insole';

  /**
   * Retrieve multiple ThermoformingInsoles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtThermoformingInsoleControllerThermoformingInsole()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params?: GetManyBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyThermoformingInsoleResponseDto>> {
    const obs = getManyBaseMgmtThermoformingInsoleControllerThermoformingInsole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ThermoformingInsoles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtThermoformingInsoleControllerThermoformingInsole(params?: GetManyBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<GetManyThermoformingInsoleResponseDto> {
    const resp = this.getManyBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyThermoformingInsoleResponseDto>): GetManyThermoformingInsoleResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` */
  static readonly CreateOneBaseMgmtThermoformingInsoleControllerThermoformingInsolePath = '/api/mgmt/thermoforming-insole';

  /**
   * Create a single ThermoformingInsole.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params: CreateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
    const obs = createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single ThermoformingInsole.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(params: CreateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<ThermoformingInsole> {
    const resp = this.createOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsole>): ThermoformingInsole => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` */
  static readonly GetOneBaseMgmtThermoformingInsoleControllerThermoformingInsolePath = '/api/mgmt/thermoforming-insole/{id}';

  /**
   * Retrieve a single ThermoformingInsole.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params: GetOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
    const obs = getOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ThermoformingInsole.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(params: GetOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<ThermoformingInsole> {
    const resp = this.getOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsole>): ThermoformingInsole => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` */
  static readonly DeleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsolePath = '/api/mgmt/thermoforming-insole/{id}';

  /**
   * Delete a single ThermoformingInsole.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params: DeleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single ThermoformingInsole.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(params: DeleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` */
  static readonly UpdateOneBaseMgmtThermoformingInsoleControllerThermoformingInsolePath = '/api/mgmt/thermoforming-insole/{id}';

  /**
   * Update a single ThermoformingInsole.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params: UpdateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
    const obs = updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single ThermoformingInsole.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(params: UpdateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<ThermoformingInsole> {
    const resp = this.updateOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsole>): ThermoformingInsole => r.body)
    );
  }

  /** Path part for operation `mgmtThermoformingInsoleControllerSortUp()` */
  static readonly MgmtThermoformingInsoleControllerSortUpPath = '/api/mgmt/thermoforming-insole/{id}/sort-up';

  /**
   * Sort Up
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtThermoformingInsoleControllerSortUp()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingInsoleControllerSortUp$Response(params: MgmtThermoformingInsoleControllerSortUp$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
    const obs = mgmtThermoformingInsoleControllerSortUp(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sort Up
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtThermoformingInsoleControllerSortUp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingInsoleControllerSortUp(params: MgmtThermoformingInsoleControllerSortUp$Params, context?: HttpContext): Observable<ThermoformingInsole> {
    const resp = this.mgmtThermoformingInsoleControllerSortUp$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsole>): ThermoformingInsole => r.body)
    );
  }

  /** Path part for operation `mgmtThermoformingInsoleControllerSortDown()` */
  static readonly MgmtThermoformingInsoleControllerSortDownPath = '/api/mgmt/thermoforming-insole/{id}/sort-down';

  /**
   * Sort Down
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtThermoformingInsoleControllerSortDown()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingInsoleControllerSortDown$Response(params: MgmtThermoformingInsoleControllerSortDown$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
    const obs = mgmtThermoformingInsoleControllerSortDown(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sort Down
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtThermoformingInsoleControllerSortDown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingInsoleControllerSortDown(params: MgmtThermoformingInsoleControllerSortDown$Params, context?: HttpContext): Observable<ThermoformingInsole> {
    const resp = this.mgmtThermoformingInsoleControllerSortDown$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsole>): ThermoformingInsole => r.body)
    );
  }

  /** Path part for operation `recoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` */
  static readonly RecoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsolePath = '/api/mgmt/thermoforming-insole/{id}/recover';

  /**
   * Recover one ThermoformingInsole.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole()` instead.
   *
   * This method doesn't expect any request body.
   */
  recoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params: RecoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = recoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Recover one ThermoformingInsole.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole(params: RecoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<void> {
    const resp = this.recoverOneBaseMgmtThermoformingInsoleControllerThermoformingInsole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` */
  static readonly GetManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStockPath = '/api/mgmt/thermoforming-base-stock';

  /**
   * Retrieve multiple ThermoformingBaseStocks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params?: GetManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyThermoformingBaseStockResponseDto>> {
    const obs = getManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ThermoformingBaseStocks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(params?: GetManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<GetManyThermoformingBaseStockResponseDto> {
    const resp = this.getManyBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyThermoformingBaseStockResponseDto>): GetManyThermoformingBaseStockResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` */
  static readonly CreateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStockPath = '/api/mgmt/thermoforming-base-stock';

  /**
   * Ajouter un stock d'une pointure d'un modèle de base de thermo donné.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params: CreateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBaseStock>> {
    const obs = createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ajouter un stock d'une pointure d'un modèle de base de thermo donné.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(params: CreateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<ThermoformingBaseStock> {
    const resp = this.createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBaseStock>): ThermoformingBaseStock => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` */
  static readonly GetOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStockPath = '/api/mgmt/thermoforming-base-stock/{id}';

  /**
   * Retrieve a single ThermoformingBaseStock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params: GetOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBaseStock>> {
    const obs = getOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ThermoformingBaseStock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(params: GetOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<ThermoformingBaseStock> {
    const resp = this.getOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBaseStock>): ThermoformingBaseStock => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` */
  static readonly DeleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStockPath = '/api/mgmt/thermoforming-base-stock/{id}';

  /**
   * Delete a single ThermoformingBaseStock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params: DeleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single ThermoformingBaseStock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(params: DeleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` */
  static readonly UpdateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStockPath = '/api/mgmt/thermoforming-base-stock/{id}';

  /**
   * Mise à jour d'un stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params: UpdateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBaseStock>> {
    const obs = updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Mise à jour d'un stock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(params: UpdateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<ThermoformingBaseStock> {
    const resp = this.updateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBaseStock>): ThermoformingBaseStock => r.body)
    );
  }

  /** Path part for operation `mgmtThermoformingBaseStockControllerGetQuantityDetails()` */
  static readonly MgmtThermoformingBaseStockControllerGetQuantityDetailsPath = '/api/mgmt/thermoforming-base-stock/{id}/quantity-details';

  /**
   * Détails de la quantité actuelle en stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtThermoformingBaseStockControllerGetQuantityDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingBaseStockControllerGetQuantityDetails$Response(params: MgmtThermoformingBaseStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBaseStockQuantityDetails>> {
    const obs = mgmtThermoformingBaseStockControllerGetQuantityDetails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Détails de la quantité actuelle en stock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtThermoformingBaseStockControllerGetQuantityDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingBaseStockControllerGetQuantityDetails(params: MgmtThermoformingBaseStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<ThermoformingBaseStockQuantityDetails> {
    const resp = this.mgmtThermoformingBaseStockControllerGetQuantityDetails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBaseStockQuantityDetails>): ThermoformingBaseStockQuantityDetails => r.body)
    );
  }

  /** Path part for operation `mgmtThermoformingBaseStockControllerGetAlerts()` */
  static readonly MgmtThermoformingBaseStockControllerGetAlertsPath = '/api/mgmt/thermoforming-base-stock/alerts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtThermoformingBaseStockControllerGetAlerts()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingBaseStockControllerGetAlerts$Response(params?: MgmtThermoformingBaseStockControllerGetAlerts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = mgmtThermoformingBaseStockControllerGetAlerts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtThermoformingBaseStockControllerGetAlerts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingBaseStockControllerGetAlerts(params?: MgmtThermoformingBaseStockControllerGetAlerts$Params, context?: HttpContext): Observable<void> {
    const resp = this.mgmtThermoformingBaseStockControllerGetAlerts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` */
  static readonly GetManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStockPath = '/api/mgmt/thermoforming-insole-stock';

  /**
   * Retrieve multiple ThermoformingInsoleStocks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params?: GetManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyThermoformingInsoleStockResponseDto>> {
    const obs = getManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ThermoformingInsoleStocks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(params?: GetManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<GetManyThermoformingInsoleStockResponseDto> {
    const resp = this.getManyBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyThermoformingInsoleStockResponseDto>): GetManyThermoformingInsoleStockResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` */
  static readonly CreateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStockPath = '/api/mgmt/thermoforming-insole-stock';

  /**
   * Ajouter un stock d'une pointure d'un modèle de semelle de thermo donné.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params: CreateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsoleStock>> {
    const obs = createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ajouter un stock d'une pointure d'un modèle de semelle de thermo donné.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(params: CreateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<ThermoformingInsoleStock> {
    const resp = this.createOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsoleStock>): ThermoformingInsoleStock => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` */
  static readonly GetOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStockPath = '/api/mgmt/thermoforming-insole-stock/{id}';

  /**
   * Retrieve a single ThermoformingInsoleStock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params: GetOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsoleStock>> {
    const obs = getOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ThermoformingInsoleStock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(params: GetOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<ThermoformingInsoleStock> {
    const resp = this.getOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsoleStock>): ThermoformingInsoleStock => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` */
  static readonly DeleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStockPath = '/api/mgmt/thermoforming-insole-stock/{id}';

  /**
   * Delete a single ThermoformingInsoleStock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params: DeleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single ThermoformingInsoleStock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(params: DeleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` */
  static readonly UpdateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStockPath = '/api/mgmt/thermoforming-insole-stock/{id}';

  /**
   * Mise à jour d'un stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params: UpdateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsoleStock>> {
    const obs = updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Mise à jour d'un stock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(params: UpdateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<ThermoformingInsoleStock> {
    const resp = this.updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsoleStock>): ThermoformingInsoleStock => r.body)
    );
  }

  /** Path part for operation `mgmtThermoformingInsoleStockControllerGetQuantityDetails()` */
  static readonly MgmtThermoformingInsoleStockControllerGetQuantityDetailsPath = '/api/mgmt/thermoforming-insole-stock/{id}/quantity-details';

  /**
   * Détails de la quantité actuelle en stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtThermoformingInsoleStockControllerGetQuantityDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingInsoleStockControllerGetQuantityDetails$Response(params: MgmtThermoformingInsoleStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsoleStockQuantityDetails>> {
    const obs = mgmtThermoformingInsoleStockControllerGetQuantityDetails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Détails de la quantité actuelle en stock.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtThermoformingInsoleStockControllerGetQuantityDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingInsoleStockControllerGetQuantityDetails(params: MgmtThermoformingInsoleStockControllerGetQuantityDetails$Params, context?: HttpContext): Observable<ThermoformingInsoleStockQuantityDetails> {
    const resp = this.mgmtThermoformingInsoleStockControllerGetQuantityDetails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsoleStockQuantityDetails>): ThermoformingInsoleStockQuantityDetails => r.body)
    );
  }

  /** Path part for operation `mgmtThermoformingInsoleStockControllerGetAlerts()` */
  static readonly MgmtThermoformingInsoleStockControllerGetAlertsPath = '/api/mgmt/thermoforming-insole-stock/alerts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtThermoformingInsoleStockControllerGetAlerts()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingInsoleStockControllerGetAlerts$Response(params?: MgmtThermoformingInsoleStockControllerGetAlerts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = mgmtThermoformingInsoleStockControllerGetAlerts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtThermoformingInsoleStockControllerGetAlerts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtThermoformingInsoleStockControllerGetAlerts(params?: MgmtThermoformingInsoleStockControllerGetAlerts$Params, context?: HttpContext): Observable<void> {
    const resp = this.mgmtThermoformingInsoleStockControllerGetAlerts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getManyBaseThermoformingInsoleControllerThermoformingInsole()` */
  static readonly GetManyBaseThermoformingInsoleControllerThermoformingInsolePath = '/api/public/thermoforming-insole';

  /**
   * Retrieve multiple ThermoformingInsoles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseThermoformingInsoleControllerThermoformingInsole()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseThermoformingInsoleControllerThermoformingInsole$Response(params?: GetManyBaseThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyThermoformingInsoleResponseDto>> {
    const obs = getManyBaseThermoformingInsoleControllerThermoformingInsole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ThermoformingInsoles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseThermoformingInsoleControllerThermoformingInsole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseThermoformingInsoleControllerThermoformingInsole(params?: GetManyBaseThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<GetManyThermoformingInsoleResponseDto> {
    const resp = this.getManyBaseThermoformingInsoleControllerThermoformingInsole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyThermoformingInsoleResponseDto>): GetManyThermoformingInsoleResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseThermoformingInsoleControllerThermoformingInsole()` */
  static readonly GetOneBaseThermoformingInsoleControllerThermoformingInsolePath = '/api/public/thermoforming-insole/{id}';

  /**
   * Retrieve a single ThermoformingInsole.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseThermoformingInsoleControllerThermoformingInsole()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseThermoformingInsoleControllerThermoformingInsole$Response(params: GetOneBaseThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
    const obs = getOneBaseThermoformingInsoleControllerThermoformingInsole(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ThermoformingInsole.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseThermoformingInsoleControllerThermoformingInsole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseThermoformingInsoleControllerThermoformingInsole(params: GetOneBaseThermoformingInsoleControllerThermoformingInsole$Params, context?: HttpContext): Observable<ThermoformingInsole> {
    const resp = this.getOneBaseThermoformingInsoleControllerThermoformingInsole$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingInsole>): ThermoformingInsole => r.body)
    );
  }

  /** Path part for operation `getManyBaseThermoformingBaseControllerThermoformingBase()` */
  static readonly GetManyBaseThermoformingBaseControllerThermoformingBasePath = '/api/public/thermoforming-base';

  /**
   * Retrieve multiple ThermoformingBases.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseThermoformingBaseControllerThermoformingBase()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseThermoformingBaseControllerThermoformingBase$Response(params?: GetManyBaseThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyThermoformingBaseResponseDto>> {
    const obs = getManyBaseThermoformingBaseControllerThermoformingBase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ThermoformingBases.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseThermoformingBaseControllerThermoformingBase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseThermoformingBaseControllerThermoformingBase(params?: GetManyBaseThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<GetManyThermoformingBaseResponseDto> {
    const resp = this.getManyBaseThermoformingBaseControllerThermoformingBase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyThermoformingBaseResponseDto>): GetManyThermoformingBaseResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseThermoformingBaseControllerThermoformingBase()` */
  static readonly GetOneBaseThermoformingBaseControllerThermoformingBasePath = '/api/public/thermoforming-base/{id}';

  /**
   * Retrieve a single ThermoformingBase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseThermoformingBaseControllerThermoformingBase()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseThermoformingBaseControllerThermoformingBase$Response(params: GetOneBaseThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBase>> {
    const obs = getOneBaseThermoformingBaseControllerThermoformingBase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ThermoformingBase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseThermoformingBaseControllerThermoformingBase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseThermoformingBaseControllerThermoformingBase(params: GetOneBaseThermoformingBaseControllerThermoformingBase$Params, context?: HttpContext): Observable<ThermoformingBase> {
    const resp = this.getOneBaseThermoformingBaseControllerThermoformingBase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ThermoformingBase>): ThermoformingBase => r.body)
    );
  }

}
